function updateFreeShippingBar() {
  let freeShippingThreshold = document.getElementById('free-shipping-bar').dataset.threshold;

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      var subtotal = cart.total_price / 100;
      var remaining = freeShippingThreshold - subtotal;
      var progress = Math.min((subtotal / freeShippingThreshold) * 100, 100);
      document.getElementById('progress-fill').style.width = progress + '%';

      if (remaining > 0) {
        document.getElementById('free-shipping-text').innerText = `Spend $${remaining.toFixed(2)} more to get free shipping!`;
      } else {
        document.getElementById('progress-fill').style.backgroundColor = "#386641";
        document.getElementById('free-shipping-text').innerText = 'You qualify for free shipping!';
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });

}
updateFreeShippingBar();

//Nasty hack to add free patch to cart when over 75$
function checkToAddFreePatch(cart){
    var patchInCart = cart.items.some(cartItem => cartItem.variant_id == 39609477201986);
    if(  ((cart.total_price / 100) <= 75) || patchInCart ){
        return;
    }

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            id: '39609477201986',
            quantity: 1
        })
    })
        .then(response => response.json())
        .then(data => {
            window.freePatchAdded = true;
            fetch('/?section_id=cart-drawer')
                .then(response => response.text())
                .then(html => {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(html, 'text/html');
                    var newCartDrawer = doc.querySelector('#CartDrawer');
                    var existingCartDrawer = document.querySelector('#CartDrawer');
                    if (existingCartDrawer && newCartDrawer) {
                        existingCartDrawer.innerHTML = newCartDrawer.innerHTML;
                    }
                    // updateFreeShippingBar();

                })
                .catch(error => {
                    console.error('Error updating cart drawer:', error);
                })
        })
        .catch(error => {
            console.error('Error adding product to cart:', error);
        })

}